import * as React from 'react';
import MotifTextLink from '@ey/motif-react-wrapper/TextLink';
import { labels } from "../../util/utils";
import styled from 'styled-components';
import { Environment } from '../../util';
import { MotifIcon } from '@ey-xd/motif-react';
import { IconoirCompass } from '@ey-xd/motif-icon';
import { EntityType } from '../../../src/util/UIConstants';
const AtlasSummary = () => {
  return (
      <StyledMainSection>
        <section className="atlas-icon-and-text">
          <MotifTextLink href={Environment.getAtlasUserInfoUrl()} target="_blank" >
            <span className="nav-icon">
              <MotifIcon src={IconoirCompass} size='20' />
            </span>
            <span className="info-text">{labels.atlasWorkpaperIndexFramework}</span>
          </MotifTextLink>
        </section>
      </StyledMainSection>
    );
}

export default AtlasSummary

const StyledMainSection = styled.section`
    display: flex;
    align-items: center;
    width: 100%;
    .atlas-icon-and-text{
      display: flex;
      align-items: center;
      width: 100%;
      height: 100%;
     .motif-text-link{
        width: 100%;
        display: flex;
        align-items: flex-start;
        height: 100%;
        margin-bottom: 0;
        font-size: var(--px-12);
        font-weight: 400;
        border-bottom: var(--px-1) solid transparent;
        &:hover{
          text-decoration: underline;
        }
        .nav-icon{
          display: flex;
          align-items: center;
          .motif-icon{
            display: flex;
            height: var(--px-20);
            width: var(--px-20);
            svg{
              margin-top: 0;
            }
          }
        }
      }
    }
`;